var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-series",attrs:{"id":_vm.chartName}})
}
var staticRenderFns = []

export { render, staticRenderFns }